import { GetCheckInDetailDataType, MySpaceType } from "./mySpaceTypes";

export const initialState: MySpaceType = {
  workAnniversaryfetching: false,
  message: null,
  error: null,
  success: null,
  statusCode: null,
  mySpaceWorkAnniversaryList: [],
  workAnniversaryTotalCount: 0,
  checkInScheduleTotalCount: 0,
  upcomingBirthdayList: [],
  upcomingBirthdayTotalCount: 0,
  upcomingBirthDayFetching: false,
  peopleOnLeaveFetching: false,
  peopleOnLeaveData: [],
  attendanceAverage: 0,
  checkInScheduleManagerViewTotalCount: 0,
  attendanceAverageFetching: false,
  checkInScheduleFetching: false,
  singleCheckInScheduleFetching: false,
  singleCheckInScheduleDetails: {},
  checkInScheduleList: [],
  checkInScheduleManagerViewList: [],
  managersAvailableCheckInScheduleSlots: [],
  peFormFetching:false,
  performanceEvaluationList:[],
  performanceEvaluationTotalCount:0,
  performanceEvaluationFetching:false,
  singlePeDetailsList:[],
  singlePeFetching:false,
  averageJobRatingList:[],
  averageJobRatingFetching:false,
  averageJobRatingCount:0,
  averageJobRatingData:0,
  viewTeamMembersFetching: false,
  viewTeamMembersData: [],
  viewTeamMembersCount: 0,
};
